import { StationInitialState, StationStateTypes } from './stationFour.state.ts';
import { createSlice } from '@reduxjs/toolkit';
import { updateStationFour } from 'store/feature/stationFour/stationFour.thunk.ts';
import { QueryState } from '@/common/enum';

const initialState: StationStateTypes = StationInitialState;

export const stationFourSlice = createSlice({
  name: 'stationFour',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(updateStationFour.pending, (state) => {
      state.queryState = QueryState.AWAIT;
      state.error = null;
    });
    builder.addCase(updateStationFour.fulfilled, (state) => {
      state.queryState = QueryState.UPDATED;
    });
    builder.addCase(updateStationFour.rejected, (state, action) => {
      state.queryState = QueryState.AWAIT;
      state.error = action.error.message ?? '';
    });
  },
});

export default stationFourSlice.reducer;
